import { useNavigate } from "react-router-dom";

function OnOffVideo() {
    const navigate = useNavigate();
    const videoEnded = () => {
        // document.getElementById("productVideo").style.display = "none";
        // document.getElementById("endImg").style.display = "inline";
        navigate("/home2")
        
      };

  return (
    <div className="App">
      <div>
        <video
          width="1000"
          autoPlay
          muted
          onEnded={videoEnded}
          id="productVideo"
        >
          <source src="/product2.mp4" type="video/mp4" />
        </video>
        {/* <img width="1000" src="/end.png" id="endImg" style={{display: "none"}}/> */}
      </div>
    </div>
  );
}

export default OnOffVideo;
